export const IMG = {
  logo: "/brand/logo.png",
  hero: "/brand/hero.png",
  bellecare: "/brand/bellecare.jpg",
  primus: "/brand/primus.jpg",
};

export const PHOTO = {
  girl: "/img/46e77cff031acaa1_IMG_2595.webp",
  hand: "/img/212de355de9a4554_IMG_1999.webp",
  spray: "/img/40ac0e821169d543_IMG_2745.webp",
  dayCream: "/img/404ade9ea421761a_IMG_2760.webp",
  dayCream2: "/img/96eae3f144db8fd8_IMG_2759.webp",
};

export const LIFESTYLE = {
  "shimmering-body-oil-primus": [PHOTO.girl, PHOTO.hand],
  "spray-body-oil-primus": [PHOTO.spray],
  "day-cream-for-face-and-neck": [PHOTO.dayCream2, PHOTO.dayCream],
};
const XI = "/img/";
const img = (m) => Object.fromEntries(Object.entries(m).map(([k, v]) => [k, `${XI}${v}.webp`]));
export const XMAS_GIRL = `${XI}79621934d0e93bac2fc1544e.webp`;
export const NY_GIRL = `${XI}7800ae04b10ef406de873a0d.webp`;
export const XMAS_PRODUCT = img({
  "shimmering-body-oil-primus": "49560be3928076db6b2ab031",
  "day-cream-for-face-and-neck": "9a356a6419f0da0009fffd03",
  "face-and-neck-cream-primus": "e89157c352ee29ad9ff972a3",
  "day-face-serum-nutritive-primus": "bfde319f27d2c20d07825b2f",
  "spray-body-oil-primus": "81cdf7400ad9310812b39e5a",
  "body-milk-balm-bellecare": "966d29156085891c8841e6e7",
  "hair-serum-bellecare": "4511f6afaa7a83691f3f694a",
  "oil-shower-gel-bellecare-natural": "ca721d1ed7a48092f0b638b1",
  "bio-gel-intimate-bellecare": "e8c571683912d4406ad30a94",
  "shower-gel-bellecare": "32b024d04730a25afc050527",
  "hair-shampoo-bellecare": "3aefafeccbde48dcd5998104",
  "hair-shampoo-bellecare-copy": "26d3dd893f4d0dc957b76db2",
  "bellecare": "e5c447052f7076a39e07c0ad",
  "cream-bellecare": "71db4f125c89209d625530bd",
  "cream-bellecare-1": "8b406b89a5a63231ff8625b9",
  "bellecare-1": "9d2f5d06b7b683deac16cf8c",
  "bellecare-2": "4d4b1f4ffc78b44121b0bb26",
  "bellecare-3": "569f7a7aed88758fdf77aa2f",
  "bellecare-4": "b7b9b9affe2edc222bc2145c",
  "bellecare-5": "6256b643cc105bac5e2d9e48",
  "bellecare-6": "be8fa6b0cf48e55345a6cda5",
  "bellecare-7": "106c68de4e9ce400c897e383",
  "bellecare-8": "95a112cbd03732050e86d66a",
  "bellecare-9": "7925859d78bef8280a3df34b",
  "bellecare-10": "98841de336ede262181f7e56",
  "bellecare-12": "9436cfa95426626f3f34c7d7",
  "day-face-serum-nutritive-primus-copy": "a78ed22fba6ae5bb3babf12e",
  "hair-oil-for-split-ends": "0b520daf08e2aaa43a5d4684",
  "bellecare-natural-shower-gel-men": "268bbe395622e417e777c2f1",
  "shhh": "d2215b12920227fed49ce5d0",
  "hair-shampoo-repair-damaged-hair": "de5d5ca3e9b647d15f8b802a",
  "hair-conditioner-repair": "91a362d5b7cdbcb98bf50db9",
  "hair-shampoo-color-amp-dry-hair": "25c1a54cf100320766e3f773",
});
export const NY_PRODUCT = img({
  "shimmering-body-oil-primus": "4ee71fabf4bd33daebb5b16d",
  "day-cream-for-face-and-neck": "ac4dbfe5f49677082f425890",
  "face-and-neck-cream-primus": "32b19ee51177f2cf86faca9e",
  "day-face-serum-nutritive-primus": "72b6d01bd17026e29c055c81",
  "spray-body-oil-primus": "7d0a941aa7634a0f035a3ae5",
  "body-milk-balm-bellecare": "8b0b522c132ad86d5d8066f4",
  "hair-serum-bellecare": "779bb5ced6ea9d24685b7ea7",
  "oil-shower-gel-bellecare-natural": "d310d562fca8c0b1d258da8c",
  "bio-gel-intimate-bellecare": "88afa0f320945859d2e2396f",
  "shower-gel-bellecare": "4d6d60ebc1d1c167a5934faa",
  "hair-shampoo-bellecare": "8ad2bbff8938436d27291d7f",
  "hair-shampoo-bellecare-copy": "cf27ba462bca197002045f59",
  "bellecare": "0bd5dfa9ed6bab9a6b5e178c",
  "cream-bellecare": "46e6ae0fe7049a8979555245",
  "cream-bellecare-1": "c02c2f176075b2305811b67f",
  "bellecare-1": "c48ee1974c663895e17d0e5b",
  "bellecare-2": "275625e5a0c3a70ef3ae7d9f",
  "bellecare-3": "b95ffd0fa23a540a1dc9904c",
  "bellecare-4": "51dcde18cd459ade0b85a64b",
  "bellecare-5": "c67345aa1f0a55eaee1d4e03",
  "bellecare-6": "ef3f6f24f42f093420c93bdd",
  "bellecare-7": "7d7d0aafb1f68c1352db3c2b",
  "bellecare-8": "32a41b17a442a380f6c55ae7",
  "bellecare-9": "2e8871ef3d4d218ff343762d",
  "bellecare-10": "ff53bcb84b6c5610b7b17c5b",
  "bellecare-12": "7984897b9caf09c550e0ea5a",
  "day-face-serum-nutritive-primus-copy": "ba356accc0657a8275395edf",
  "hair-oil-for-split-ends": "578f0536104f26f506da5c10",
  "bellecare-natural-shower-gel-men": "579ea4d7d38ff79e5e1ada76",
  "shhh": "741ceea880b8becb7f1467e1",
  "hair-shampoo-repair-damaged-hair": "01e3e471b5da3df08feaa294",
  "hair-conditioner-repair": "dff05c1de2ddd7505babf9db",
  "hair-shampoo-color-amp-dry-hair": "688e78aedf130b4eda82aab8",
});
export const ING_PHOTO = img({
  almond: "9e6bb5b89ff4c41d59fabbe2", aloe: "2db01125af151a922577fc5b",
  apricot: "ab8ba8d5325ff3c307c5b5e4", argan: "694f52d103f965bca4896ad1",
  arnica: "4579b61e8f616885c90dcf10", avocado: "b3b500b8d00a83a80f0d0ebb",
  bitter_orange: "b11c8ae1bfe072c37a02f8bd", black_seed: "d7c0f14904e95229ca2f1224",
  calendula: "c3124f00f32703cc0e2b3ae4", carrot: "1827cd0f4638adcb6814260a",
  castor: "440a40cb06105159f2b9a0e8", centella: "bb17c8db93ad2f72f15e5f1d",
  chamomile: "17b57bef1c89a501e03019cb", chestnut: "b1f9f4b1fae977863b93b73d",
  coconut: "e6c4119b1f699731714856b0", cocoa: "c1136452aebc7c478f232b4f",
  comfrey: "43b8941535f5f3cd09f185cf", cranberry: "9696ef9b3122bb8608a76688",
  cucumber: "4abad3599cf723ac2b86ef76", devils_claw: "863922a72367ea8a3c329cfc",
  eucalyptus: "d8f847ec0c89d35c093762ad", evening_primrose: "862f9d510cb16b6ab04966a7",
  ginger: "ff930c1d652b22243cfec08c", glycerin: "905309595ff19bccedaf78da",
  green_tea: "f4ed93f0fed804738c01e702", henna: "5c058199502f18ee3bca3093",
  horsetail: "120b5468da7ec2bc79c2fd12", hyaluronic: "b19854e42d870a4d4bbf9148",
  collagen: "e9a34d831ef54521a33992b0", immortelle: "17fd6af2fe07f625fbe15d05",
  jojoba: "35660cac45429b0eff4bec53", linden: "142583ce26b8e6f22f0b3ec8",
  linseed: "d33841c6cb317129d3744081", macadamia: "962314be310196b455d60735",
  magnesium: "cf33ae662613d565dbd35af4", mandarin: "c9b9911a45b6d808f496d36d",
  menthol: "bd7ec7ebddf8b57c0a93d6dc", peppermint: "976e9747f032be194ea0a78a",
  niacinamide: "ec83ebb291fb6c68f3f8f626", oat: "2a6b4c7b93e10fbe338e82b9",
  olive: "25edb1144afe7d8234510572", panthenol: "a918dff08464dce450887d27",
  pomegranate: "82e1079477588941da759f4c", red_grape: "77a8b6a60f62b7567a1397fe",
  grapeseed: "aa0392819cd9754aca98cc02", rose: "b116765d46b39341cd7b1f87",
  rosemary: "83570541be6c0355116c0d93", sage: "4c3c273ac88e443ec3e97fa1",
  shea: "a07910cc6ff4e0cc53287cb1", spirulina: "2cb56350b35b4af2749f3197",
  st_johns_wort: "d5802494bbf17cfe005847a9", sunflower: "4ec6432500288e532652da0b",
  tea_tree: "1982cdb9e33bc06dab4686a8", turmeric: "88b95fc4ced083705b05d576",
  verbena: "4a313ab1870a79f9b383e7e8", vitamin_e: "4275253684c6fd94fdc0cb01",
  walnut: "30d81f38b659c5e63afe5076", wheat_germ: "5af2c1d8a0c62044355da5ea",
  white_tea: "9ed28cbf83439700e1633b1a", witch_hazel: "c2069c49d02ed4196d127935",
});
export const LIFESTYLE_SET = new Set([...Object.values(LIFESTYLE).flat(), ...Object.values(XMAS_PRODUCT), ...Object.values(NY_PRODUCT), XMAS_GIRL, NY_GIRL]);

export const LIFESTYLE_GALLERY = [
  { src: PHOTO.girl, handle: "shimmering-body-oil-primus", name: "Shimmering Body Oil" },
  { src: PHOTO.spray, handle: "spray-body-oil-primus", name: "Spray Body Oil" },
  { src: PHOTO.dayCream2, handle: "day-cream-for-face-and-neck", name: "Day Face + Neck Cream" },
  { src: PHOTO.hand, handle: "shimmering-body-oil-primus", name: "Shimmering Body Oil" },
  { src: PHOTO.dayCream, handle: "day-cream-for-face-and-neck", name: "Day Face + Neck Cream" },
];

export const ING_IMG = {
  oil: "/img/ed41cc375c9bc6383551b3910fd8dca9c5d91274ccfa3f6e40e0ad9fcbfc.webp",
  seed: "/img/75b095ab5556251eab232b2ad8380cbc690a6978abcc0226a03670aad515.webp",
  vitamin: "/img/76dbae33262a19dff244d33f9f479f625487a17bebed38de5a5141e59855.webp",
  aloe: "/img/58785ffdf5fefb6dee36eeaa21e5e6157d99c1f87d0335c57ebe3f358beb.webp",
  botanical: "/img/ef9dbf8172d481f1b9df433265f3bb8e0a3290cf98edb8c90cb053a9cb68.webp",
  fruit: "/img/602acad786f7ae280f2f5b03763ff10deb3ba7638449807f1f6ca4206828.webp",
  hydration: "/img/9f7be1f2ba6090b43e66acba5b045ba972a1415cfc50830207409c7fb503.webp",
  mineral: "/img/ba64a1d175f401e864643989d2e207757fbe391311243f2d377a713787cf.webp",
  butter: "/img/9f417ee33810bf7a9bee85f37b44ee03df04fc4f84bcc9347782f3b5d32f.webp",
  flower: "/img/1ef906790ee600991af8af82a822cae9d9b680df556ec7292a8dfe01ae64.webp",
};

export const BUNDLE_HANDLES = ["oil-shower-gel-bellecare-natural", "bellecare-natural-shower-gel-men", "bio-gel-intimate-bellecare"];

// Sample reviews – texts live in backend/ui_strings.json (review_0..4); replace with real customer reviews.
export const REVIEWS = [
  { name: "Lejla M.", city: "Vienna", rating: 5, g: "f", product: "Primus Shimmering Body Oil", handle: "shimmering-body-oil-primus" },
  { name: "Marko T.", city: "Zagreb", rating: 5, g: "m", product: "Bellecare Shower Gel for Men", handle: "bellecare-natural-shower-gel-men" },
  { name: "Sophie K.", city: "Munich", rating: 5, g: "f", product: "Primus Night Face + Neck Cream", handle: "face-and-neck-cream-primus" },
  { name: "Amra H.", city: "Ljubljana", rating: 4, g: "f", product: "Bellecare Hair Serum", handle: "hair-serum-bellecare" },
  { name: "Elena R.", city: "Milan", rating: 5, g: "f", product: "Bellecare Body Milk Balm", handle: "body-milk-balm-bellecare" },
  { name: "Luka P.", city: "Split", rating: 5, g: "m", product: "Primus Spray Body Oil", handle: "spray-body-oil-primus" },
  { name: "Ivana B.", city: "Rijeka", rating: 5, g: "f", product: "Primus Day Face + Neck Cream", handle: "day-cream-for-face-and-neck" },
  { name: "Thomas W.", city: "Graz", rating: 5, g: "m", product: "Bellecare Oil Shower Gel", handle: "oil-shower-gel-bellecare-natural" },
  { name: "Ana S.", city: "Zadar", rating: 5, g: "f", product: "Primus Day Face Serum", handle: "day-face-serum-nutritive-primus" },
  { name: "David L.", city: "Berlin", rating: 4, g: "m", product: "Bellecare Repair Shampoo", handle: "hair-shampoo-repair-damaged-hair" },
  { name: "Maja K.", city: "Osijek", rating: 5, g: "f", product: "Bellecare Intimate Bio Gel", handle: "bio-gel-intimate-bellecare" },
  { name: "Nikola J.", city: "Belgrade", rating: 5, g: "m", product: "Bellecare Hair Oil", handle: "hair-oil-for-split-ends" },
];

export const RESULTS = [98, 91, 100];
export const TRUST_ICONS = ["Truck", "ShieldCheck", "RotateCcw", "Leaf"];
